(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hot-collection-style"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('hot-collection-card')) {
    customElements.define('hot-collection-card', class extends HTMLElement {
      connectedCallback() {
        if (!this.hasAttribute('data-tilt')) return;
        this.controls = new AbortController();
        this.motion = matchMedia('(hover: hover) and (pointer: fine) and (prefers-reduced-motion: no-preference)');
        const media = this.querySelector('.hc-card__media');
        media.addEventListener('pointermove', event => {
          if (!this.motion.matches || event.pointerType === 'touch') return;
          cancelAnimationFrame(this.frame);
          const x = event.clientX;
          const y = event.clientY;
          this.frame = requestAnimationFrame(() => {
            const bounds = media.getBoundingClientRect();
            const rx = Math.max(-14, Math.min(14, (.5 - (y - bounds.top) / bounds.height) * 28));
            const ry = Math.max(-14, Math.min(14, ((x - bounds.left) / bounds.width - .5) * 28));
            this.style.setProperty('--hc-rx', rx.toFixed(2) + 'deg');
            this.style.setProperty('--hc-ry', ry.toFixed(2) + 'deg');
          });
        }, { signal: this.controls.signal });
        media.addEventListener('pointerleave', () => this.reset(), { signal: this.controls.signal });
        this.motion.addEventListener('change', () => this.reset(), { signal: this.controls.signal });
      }
      reset() {
        cancelAnimationFrame(this.frame);
        this.style.removeProperty('--hc-rx');
        this.style.removeProperty('--hc-ry');
      }
      disconnectedCallback() {
        this.controls?.abort();
        cancelAnimationFrame(this.frame);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hot-product-style"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('hot-product-gallery')) {
    customElements.define('hot-product-gallery', class extends HTMLElement {
      connectedCallback() {
        this.controls = new AbortController();
        this.motion = matchMedia('(hover: hover) and (pointer: fine) and (prefers-reduced-motion: no-preference)');
        this.addEventListener('pointermove', (event) => {
          if (!this.motion.matches || event.pointerType === 'touch') return;
          if (this.frame) cancelAnimationFrame(this.frame);
          const x = event.clientX;
          const y = event.clientY;
          this.frame = requestAnimationFrame(() => {
            const bounds = this.getBoundingClientRect();
            const rx = Math.max(-9, Math.min(9, (.5 - (y - bounds.top) / bounds.height) * 18));
            const ry = Math.max(-9, Math.min(9, ((x - bounds.left) / bounds.width - .5) * 18));
            this.style.setProperty('--hp-rx', rx.toFixed(2) + 'deg');
            this.style.setProperty('--hp-ry', ry.toFixed(2) + 'deg');
          });
        }, { signal: this.controls.signal });
        this.addEventListener('pointerleave', () => this.reset(), { signal: this.controls.signal });
        this.addEventListener('focusout', () => this.reset(), { signal: this.controls.signal });
        this.motion.addEventListener('change', () => this.reset(), { signal: this.controls.signal });
      }
      reset() {
        cancelAnimationFrame(this.frame);
        this.style.removeProperty('--hp-rx');
        this.style.removeProperty('--hp-ry');
      }
      disconnectedCallback() {
        this.controls?.abort();
        cancelAnimationFrame(this.frame);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
